import { ZodEffects, ZodObject } from "zod";
import type { ZodTypeAny } from "zod";

export function getShape(schema: ZodTypeAny): Record<string, any> {
  if (schema instanceof ZodObject) {
    return schema.shape;
  }
  if (schema instanceof ZodEffects) {
    return getShape(schema._def.schema); // recursivo hasta llegar al ZodObject
  }
  return {};
}
